import { Skeleton } from '@mui/material'

export const virtualizedListDefaultProps = {
  itemSize: 57,
  overscanCount: 3,
  SkeletonItem: () => <Skeleton variant="rectangular" height={56} />,
}
